// src/components/dentally/DentallyTreatmentMappingContent.jsx
//
// Inline host of the existing treatment catalogue + appointment-reason mapping
// tool (DentallyTreatmentSyncWizard). Same data, mutations, matching rules and
// apply actions as the dialog opened from Integration settings.
import PropTypes from 'prop-types';
import DentallyTreatmentSyncWizard from './DentallyTreatmentSyncWizard';

export default function DentallyTreatmentMappingContent({ practiceId }) {
  return <DentallyTreatmentSyncWizard inline practiceId={practiceId} />;
}

DentallyTreatmentMappingContent.propTypes = {
  practiceId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
